module.exports = __webpack_public_path__ + "img/hawaii.995bcb6c.svg";